import { Component, ViewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Table } from 'primeng/table';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-snp-list',
  templateUrl: './snp-list.component.html',
  styleUrls: ['./snp-list.component.css']
})
export class SnpListComponent {
  @ViewChild('dt1') dt1: Table;

  snps: any[];
  loading: boolean = true;
  selectedSample: any;

  constructor(private dataService: DataService,
    private router: Router) { }

  ngOnInit() {
      this.dataService.getSnpList().then(data => {
        this.snps = data;
        this.loading = false;
      });
  }

  clear(table: Table) {
      table.clear();
  }

  applyFilterGlobal($event:any, stringVal:any) {
    this.dt1.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  rowClick(snpRecord: any){
    this.router.navigate(['detail',snpRecord.sampleId]);
  }
}
